<template>
  <footer class="footer footer-legalbar">
    <div class="container-fluid">
      <div class="row align-items-center">

        <!-- Izquierda: copyright -->
        <div class="col-12 col-lg-4 px-0 mb-2 mb-lg-0">
          <div
            class="text-sm copyright text-white"
            :class="this.$store.state.isRTL ? 'text-sm-end' : 'text-sm-start'"
          >
            ©{{ new Date().getFullYear() }} Quanty
          </div>
        </div>

        <!-- Derecha: enlaces legales -->
        <div class="col-12 col-lg-8 px-0">
          <div class="legal-links" :class="this.$store.state.isRTL ? 'rtl' : ''">
            <router-link to="/contacto">Contacto</router-link>            
            <span class="sep">|</span>
            <router-link to="/politica-privacidad">Privacidad</router-link>
            <span class="sep">|</span>
            <router-link to="/aviso-legal">Aviso legal</router-link>
            <span class="sep">|</span>
            <router-link to="/politica-cookies">Cookies</router-link>
            <span class="sep">|</span>
            <button class="legal-btn cookie-trigger" type="button" @click="openCookiePreferences">
              <i class="fas fa-cookie-bite"></i>
              <span>Preferencias</span>
            </button>



            
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
  methods: {
    openCookiePreferences() {
      // 1) Si existe la API global, perfecto
      if (window.QuantyConsent && typeof window.QuantyConsent.showPreferences === "function") {
        window.QuantyConsent.showPreferences();
        return;
      }

      // 2) Si no existe, pedimos al CMP que se abra por evento (modo robusto)
      window.dispatchEvent(new CustomEvent("quanty:open-cookie-preferences"));

      // 3) Por si el banner monta con delay, reintento corto
      setTimeout(() => {
        if (window.QuantyConsent && typeof window.QuantyConsent.showPreferences === "function") {
          window.QuantyConsent.showPreferences();
        }
      }, 150);
    },
  },

};
</script>

<style>
/* barra inferior */
.footer-legalbar{
  background:#0d3b66 !important;
  border-top:1px solid rgba(255,255,255,.08);
  padding:4px 10px;
}
.footer-legalbar:hover {
  background:#0d3b66 !important;
  color: inherit !important;
}

/* copyright */
.text-sm.copyright{
  font-size:0.72rem!important;
  line-height:1rem;
  margin:0;
  border:0!important;
}

/* links */
.legal-links{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  gap:6px;
  flex-wrap:wrap;
  font-size:0.8rem;
}

.legal-links.rtl{
  justify-content:flex-start;
}

.legal-links a{
  color:#fff !important;
  text-decoration:none;
  opacity:.95;
  font-weight:600;
  background: transparent !important;
}

.legal-links a:hover{
  opacity:1;
  text-decoration:underline;
  background: transparent !important;
  color: #fff !important;
}

.legal-btn{
  border:0;
  background:transparent;
  color:#fff;
  opacity:.95;
  font-weight:700;
  padding:0;
  margin:0;
  cursor:pointer;
  font-size:0.85rem;
}

.legal-btn:hover{
  opacity:1;
  text-decoration:underline;
}
.cookie-trigger{
  display:inline-flex;
  align-items:center;
  gap:4px;
  background:rgba(255,255,255,.08);
  padding:2px 8px;
  border-radius:16px;
  transition:all .2s ease;
}

.cookie-trigger:hover{
  background:rgba(255,255,255,.18);
  transform:translateY(-1px);
}

.sep{
  color:rgba(255,255,255,.45);
}

/* responsive: centra en móvil */
@media (max-width: 991px){
  .legal-links{
    justify-content:flex-start;
  }
}
@media (max-width: 576px){
  .cookie-trigger span{
    display:none;
  }
}
/* ===============================
   MOBILE COMPACT MODE
=================================*/
@media (max-width: 576px){

  .footer-legalbar{
    padding:2px 6px;          /* menos alto */
  }

  .text-sm.copyright{
    font-size:0.65rem!important;
    line-height:0.9rem;
    text-align:center;
    margin-bottom:4px;
  }

  .legal-links{
    font-size:0.70rem;
    gap:4px;
    justify-content:center;
  }


  .legal-links a{
    font-weight:500;
  }

  .cookie-trigger{
    padding:2px 6px;
    border-radius:12px;
  }

  .cookie-trigger i{
    font-size:0.75rem;
  }
}
/* ===============================
   FOOTER SINGLE LINE ALL DEVICES
=================================*/

.footer-legalbar .row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  flex-wrap:nowrap;
}

/* anulamos el comportamiento bootstrap */
.footer-legalbar .col-12{
  flex:unset;
  width:auto;
}

/* izquierda */
.text-sm.copyright{
  white-space:nowrap;
}

/* derecha */
.legal-links{
  justify-content:flex-end;
  flex-wrap:nowrap;
  white-space:nowrap;
}
</style>
